import React from "react"
import { useSelector } from "react-redux"

import { VIEW, EDIT } from "const"
import { mtUsersRoute } from "client/parts/routes"
import { StoreType } from "client/store"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"

import List from "./list"
import View from "./view"
import Edit from "./edit"

const MtUser = () => {
    const userData = useSelector((state: StoreType) => state.system.userData)
    return userData.accountId === 1
        ? (
            <Switch>
                <Route
                    exact
                    path={mtUsersRoute}
                    component={List}
                />
                <Route
                    path={`${mtUsersRoute}/${VIEW}/:userId`}
                    component={View}
                />
                <Route
                    path={`${mtUsersRoute}/${EDIT}/:userId`}
                    component={Edit}
                />
            </Switch>
        )
        : <AccessDenied />
}
export default MtUser
